import { render, staticRenderFns } from "./EditTurnModal.vue?vue&type=template&id=27f43e9c&scoped=true&"
import script from "./EditTurnModal.vue?vue&type=script&lang=ts&"
export * from "./EditTurnModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditTurnModal.vue?vue&type=style&index=0&id=27f43e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f43e9c",
  null
  
)

export default component.exports